import * as Sentry from '@sentry/react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActivityForm from "features/forms/Activity";
import AssignmentAi from 'utils/assets/images/Assignment_ai.png';
import AssignmentForm from "features/forms/AssignmentForm";
import COLOR from "utils/constants/color";
import QuizForm from "features/forms/Quiz";
import moment from "moment";
import styled from "styled-components";
import { DeleteModal } from "components/Dialog";
import { Drawer, Col, Dropdown, Space, Tooltip } from "antd";
import { TootipWrapper } from "components/TooltipWrapper";
import { handleDeleteCustomAssignment } from "store/activities/thunks";
import { handleListSubmissionsByAssignmentAndClass } from "store/submissions/thunks";
import { handleGetClass } from "store/classes/thunks";
import { handleBulkUpdateCanvasAssignment, handleDeleteCanvasAssignment } from "store/canvas/thunks";
import { handleDeleteGoogleAssignment, handleUpdateGoogleAssignment } from "store/googleClassRoom/thunks";
import { handleUpdateSchoologyAssignment } from "store/schoologyauth/thunks";
import { imageFetch, imageFetchFromPodcast, isVideo, groupLinkedSection } from "utils/lib/ebookHelper";
import { isAfterTime, isScheduledToday, isValidColorCode } from "utils/methods/math";
import { lighten, invert } from "polished";
import { filter, get, find, debounce, isEmpty } from "lodash";
import { useAiAnswerView } from "store/main_book_popup/selectors";
import { useAllBook } from "store/books/selectors";
import { useAllDistrictTeacher } from "store/users/selectors";
import { useClassUsers, useUsersByClass } from "store/userClasses/selectors";
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { useExams } from "store/exams/selectors";
import { useMobileDetect, useIsTab } from "containers/chat/hooks";
import { useResources } from "store/resources/selectors";
import { useSocket } from "store/chat/selectors";
import { v4 } from 'uuid';
import AssignableNotificationShare from "./AssignableNotificationShare";
import AssignmentReviewByNotify from "./AssignmentReviewByNotify";
import DeleteAssignment from "./DeleteAssignment";
import ExamsSharedAndAssignedTask from "./ExamsSharedAndAssigned";
import Loading from "./Loading";
import PrintPage from "./PrintPage";
import SharedAndAssignedTask from "./SharedAndAssigned";
import { NoteMark } from "./UI";
import SentryWrap from 'components/Sentry';
import {
  CopyAllOutlined,
  KeyboardArrowDown,
} from '@mui/icons-material';
import {
  handleUpdateClassQuiz,
  handleChangeStatusQuizzes,
  handleListClassQuizzes,
} from "store/classQuizzes/thunks";
import {
  handleListClassActivities,
  handleChangeStatusActivity,
  handleUpdateClassActivity,
  handleGraphicOrgCustomActivityUpdate,
  handleListActivityOrQuizData,
} from "store/classActivities/thunks";
import {
  FormControlLabel,
  IconButton,

} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CustomSwitch } from './CustomSwitch';
import { useOwnGraphicOrganizers } from 'store/activities/selectors';
import { usePageCover } from './hooks/pageCover/pageCover';
import { handleDeleteSchoologyAssignment } from 'store/schoology/thunks';
import ShowStoryBtn from './ShowStoryButton';
import customEditSvg from '../utils/assets/images/customEdit.svg';
import titleIconSvg from '../utils/assets/images/titleIcon.svg';
import clockSvg from '../utils/assets/images/Clock.svg';
import dueDateSvg from '../utils/assets/images/dueDate.svg';
import lastSubSvg from '../utils/assets/images/last-sub.svg';
import statusSvg from '../utils/assets/images/status.svg';
import assignSvg from '../utils/assets/images/assign.svg';
import eyeBtnSvg from '../utils/assets/images/eyeBtn.svg';
import editorIconSvg from '../utils/assets/images/editorIcon.svg';
import CloneActivityToPageModal from './CloneActivityToPageModal';
import WorksheetAssignment from 'modules/workSheet/WorksheetAssignment';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const ASSIGNMENT_BG = ['#cfd5d045', '#dbe4f0', '#58aedb4f', '#dda4e74d', '#3fdd6645', '#e9bf864d'];
const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;


const Row = styled.div`
  align-items: ${(p) => p.align || "center"};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;
  width: 100%;

  &:last-child {
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 0px;
  }
`;

const Text = styled.span`
  color: ${COLOR.black500};
  margin-top: 2px;
  text-align: left;
  font-family: Arial;
font-size: 9px;
font-style: normal;
font-weight: 400;
line-height: normal;
`;

const TextLarge = styled(Text)`
  color: ${COLOR.green100};
  font-size: 14px;
  font-weight: 600;
  margin-right: 4px;
`;

const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
`;

const Wrapper = styled.div`
  // background-color: ${(p) => p.deactivated ? "#F5D9FF" : p.bgColor ? p.bgColor : "#C6E5E4"};
  // border: 2px soild ${(p) => p.deactivated ? "#94ADD1" : p.bgColor ? lighten(0.2, invert(p.bgColor)) : lighten(0.3, COLOR.green100)};
  
  border: 2px solid ${(p) => p.isGraphicOrganizer ? "#372b62":  p.bgColor ? p.bgColor : p.isGeneratedTest ? '#2C3A47' : '#88ADE2'};
  border-radius: 11px;
  color: ${COLOR.green100};
  // cursor: ${(p) => (p.disabled ? "no-drop" : "pointer")};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 16px;
  outline: none;
  padding: 12px 12px 10px;
  transition: all 300ms ease;
  width: 100%;
  background: ${(p) => p.deactivated ? "rgba(255,0,0,0.2)" : (p.bgColor && !ASSIGNMENT_BG.includes(p.bgColor) ? p.bgColor : "#fff")};
  position: relative;
  padding-left: 30px;

  &::before {
    width: 20px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: ${(p) => p.isGraphicOrganizer ? "#372b62":  p.bgColor ? p.bgColor : p.isGeneratedTest ? '#cffafe' : '#88ADE2'};
    content: "";
    border-radius: 8px 0px 0px 8px;
  }

  // &:hover {border: 2px solid ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
  // &:hover&::before {background: ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
  @media (max-width:425px){
    padding-right: 0px !imprtant;
  }
`;

/* <-------------------------New-exame-design css-------------------------> */
const ExamAssignmentWrapper = styled.div`
  // position: relative;
  // background-color: ${(p) => p.deactivated ? "#F5D9FF" : p.bgColor ? p.bgColor : "#C6E5E4"};
  // border: 2px dashed ${(p) => p.deactivated ? '#94ADD1' : p.bgColor ? lighten(0.2, invert(p.bgColor)) : lighten(0.3, COLOR.green100)};
  // border-radius: 11px;
  // color: ${COLOR.green100};
  // cursor: ${(p) => (p.disabled ? 'no-drop' : 'pointer')};
  // font-size: 14px;
  // font-weight: 400;
  // margin-bottom: 16px;
  // outline: none;
  // padding: 12px 12px 10px;
  // transition: all 300ms ease;
  // width: 100%;
  // &:hover { background-color: ${(p) => p.deactivated ? "rgba(255,0,0,0.2)" : lighten(0.55, COLOR.green100)};}
  

  // background-color: ${(p) => p.deactivated ? "#F5D9FF" : p.bgColor ? p.bgColor : "#C6E5E4"};
  // border: 2px soild ${(p) => p.deactivated ? "#94ADD1" : p.bgColor ? lighten(0.2, invert(p.bgColor)) : lighten(0.3, COLOR.green100)};
  
  border: 2px solid ${(p) => p.bgColor ? p.bgColor : p.isUnitExam ? '#ffa947' : p.isGeneratedTest ? '#2C3A47' : '#88ADE2'};
  border-radius: 11px;
  color: ${COLOR.green100};
  // cursor: ${(p) => (p.disabled ? "no-drop" : "pointer")};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 16px;
  outline: none;
  padding: 12px 12px 10px;
  transition: all 300ms ease;
  width: 100%;
  background: ${(p) => p.deactivated ? "rgba(255,0,0,0.2)" : (p.bgColor && !ASSIGNMENT_BG.includes(p.bgColor) ? p.bgColor : "#fff")};
  position: relative;
  padding-left: 30px;
  &::before {
    width: 20px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: ${(p) =>  p.bgColor ? p.bgColor : p.isUnitExam ? '#CCE4E4' : p.isGeneratedTest ? '#cffafe' : '#88ADE2'};
    content: "";
    border-radius: 8px 0px 0px 8px;
  }
  // &:hover {border: 2px solid ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
  // &:hover&::before {background: ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}

`;

/* <-------------------------End New-exame-design css-------------------------> */

const useStyles = makeStyles({
  root: {
    //   margin: "5px",
    // width: '175px'
  },
  sizeSmall: {
    width: "55px",
    height: "25px",
  },
  checkedSwitch: {
    transform: "translateX(30px) !important",
  },
  label: {
    textTransform: "uppercase",
    color: "#3E5F8F !important",
    fontFamily: "Arial !important",
    fontSize: "8px !important",
    fontWeight: "700 !important",
  },
});

const DropDownMenu = ({ data, currentClass, onClassClick, loading }) => {
  const [open, setOpen] = useState(false);

  const items = data?.map((item, index) => ({
    key: index,
    label: item.displayName || "",
    className: item.id === currentClass?.id ? 'selected-class-item' : '',
    onClick: async ({ key }) => {
      const selectedItem = data[parseInt(key)];
      if (!selectedItem || selectedItem.id === currentClass?.id) {
        setOpen(false);
        return;
      }
      if (onClassClick && !loading) {
        await onClassClick(selectedItem);
        setOpen(false);
      }
    },
  }))||[];

  const handleOpenChange = (newOpen) => {
    if (!loading) {
      setOpen(newOpen);
    }
  };

  return (
    <Space direction="vertical">
      <Space wrap>
        <Dropdown 
          className='assignInfoStatus' 
          menu={{ items }} 
          arrow
          overlayClassName="class-dropdown-menu"
          open={open}
          onOpenChange={handleOpenChange}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {data?.length > 1
              ? " Assigned to multiple class"
              : " Assigned to single class"}
            {loading ? (
              <Loading size={16} />
            ) : (
              <KeyboardArrowDown style={{ fontSize: "medium" }} />
            )}
          </div>
        </Dropdown>
      </Space>
    </Space>
  );
};

const StudentListDropdown = ({ assignment, classUsers, currentClass }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const getAssignedStudents = () => {
    if (!assignment?.classes || !classUsers) return [];

    const classConfig = assignment.classes.find((cls) => cls?.id === currentClass?.id);
    if (!classConfig || !Array.isArray(classConfig.users) || classConfig.users.length === 0) return [];

    const selectedIds = new Set(classConfig.users);
    return classUsers.filter((user) => selectedIds.has(user.id) && user.role === 'student');
  };

  const assignedStudents = getAssignedStudents();
  const studentCount = assignedStudents.length;

  return (
    <div 
      className='studentListDropdown'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className='studentListDropdown-trigger'>
        <span style={{fontSize: 'auto'}}>Student list</span>
        <KeyboardArrowDown className='studentListDropdown-icon' />
      </div>
      
      {isHovered && assignedStudents.length > 0 && (
        <div className='studentListDropdown-menu'>
          <div className='studentListDropdown-header'>
            Assigned Students ({studentCount})
          </div>
          {assignedStudents.map((student, index) => (
            <div key={student.id} className='studentListDropdown-item'>
              {student.firstName} {student.lastName}
            </div>
          ))}
        </div>
      )}
      
      {isHovered && assignedStudents.length === 0 && (
        <div className='studentListDropdown-empty'>
          No students assigned
        </div>
      )}
    </div>
  );
};


const AssignedNotification = ({
  assignment,
  currentClass,
  onPreviewCick = () => null,
  isAssignedAllExam,
  viewType = "",
  is_extension_activity = false,
  extensionActivityData={},
  engageData={},
  is_engage_activity=false,
  worksheetData = [],
}) => {
  const bookAllList = useAllBook();
  const classes = useStyles();
  const dispatch = useDispatch();
  const isTablate = useIsTab();
  const isMobile = useMobileDetect();
  const classUsers = useClassUsers();
  const usersByClass = useUsersByClass()
  const ownGraphicOrganizer = useOwnGraphicOrganizers();
  const { socketConnection, reCreateSocket } = useSocket();
  const { invokeAiAnswerView } = useAiAnswerView();
  const [activityDrawer, toggleActivityDrawer] = useState(false);
  const [quizDrawer, toggleQuizDrawer] = useState(false);
  const [activityData, setActivityData] = useState(assignment);
  const [quizData, setQuizData] = useState(assignment);
  const currentUser = useSelector((state) => state.currentUser);
  const userClasses = useSelector((state) => state.userClasses);
  const isSchoologyUser = !!(currentUser?.schoologyid);
  const linkedSectionIdForCurrentClass = useMemo(() => {
    if (!currentClass?.id || !userClasses?.length || !isSchoologyUser) return null;
    const linkedBySection = groupLinkedSection(userClasses, isSchoologyUser);
    const sectionKey = Object.keys(linkedBySection).find(key =>
      (linkedBySection[key] || []).some(c => String(c.id) === String(currentClass.id))
    );
    return sectionKey || null;
  }, [currentClass?.id, userClasses, isSchoologyUser]);
  const linkedSectionClassIds = useMemo(() => {
    if (!linkedSectionIdForCurrentClass || !userClasses?.length || !isSchoologyUser) return null;
    const linkedBySection = groupLinkedSection(userClasses, isSchoologyUser);
    const group = linkedBySection[linkedSectionIdForCurrentClass];
    return Array.isArray(group) ? group.map(c => String(c.id)) : null;
  }, [linkedSectionIdForCurrentClass, userClasses, isSchoologyUser]);
  const [dataLoading, setDataLoading] = useState(false);
  const [reviewLoader, setReviewLoader] = useState(false);
  const [durationSection, setDurationSection] = useState(false);
  const [fetchSelectedRubric, setFetchSelectedRubric] = useState(null);
  const [templateType, setTemplateType] = useState(null);
  const [editCustomAssignmentData, setEditCustomAssignmentData] =
    useState(null);
  const [editCustomAssignmentModal, setEditCustomAssignmentModal] =
    useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
  const [classSwitchLoading, setClassSwitchLoading] = useState(false);
  // const isActive = get(assignment, "active", true);
  const [isActive, setIsActive] = useState(get(assignment, "active", true));
  const activeTogglePendingRef = useRef(null);
  const prevAssignmentIdRef = useRef();
  const colorCode = isValidColorCode(get(assignment, "data.colorCode"))
    ? get(assignment, "data.colorCode")
    : null;
  const { createNotificationAssignment } = useCollectionNotification();
  const [cloneToPageOpen, setCloneToPageOpen] = useState(false);
  const allDistrictTeacher = useAllDistrictTeacher();
  const filterByTeacher = allDistrictTeacher.find(
    (item) => item.id === assignment.data.share_by
  );
  const filterByBook =
    bookAllList.find((book) => book.id === assignment.data.chapter) || {};
  const chapter = get(assignment, "data.chapter")
  const assignment_page =  get(assignment, "data.page")
  const resources = useResources()
  const exams = useExams();
  const pageCover = usePageCover({ assignmentData: assignment?.data });
  const modalSrc = useMemo(() => pageCover? pageCover : isVideo(chapter, resources) ? imageFetchFromPodcast(chapter, resources) : imageFetch(bookAllList, chapter, assignment_page),[resources,bookAllList,assignment_page,chapter,assignment?.id, pageCover]);
  const examBookIds = exams?.flatMap((entry) =>
    entry.exams.map((exam) => `${exam.bookId}`)
  );
  const is_exam =  !!get(assignment, "data.is_exam")
  const isUnitExam = get(assignment, 'data.is_unit_exam');
  const isExam = is_exam || isUnitExam;
  const isGeneratedTest = Boolean(get(assignment, 'data.generated_test'));
  const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);

  const view_result_on = useMemo(() => {
    const result_visibility_on = assignment?.result_visibility_on;
    const show_msg = result_visibility_on ? isAfterTime(result_visibility_on) : false
    if (show_msg) return moment(result_visibility_on).format('MMM DD, YYYY hh:mm A')
    return null;
  }, [assignment])

  const showAssignToForCurrentClass = useMemo(() => {
    const cls = assignment?.classes?.find((c) => c?.id === currentClass?.id);
    return !!(cls && Array.isArray(cls.users) && cls.users.length > 0);
  }, [assignment?.classes, currentClass?.id]);

  const storyInstructionView = assignment?.storyInstruction || assignment?.data?.storyInstruction;
  const invokSend = (data) => {
    let socket = socketConnection ?? "";
    if (socket) {
      try {
        if (socket.readyState == 3) {
          reCreateSocket();
          setTimeout(() => {
            socket.send(JSON.stringify(data));
          }, 2000);
        } else {
          socket.send(JSON.stringify(data));
        }
      } catch (error) {
        console.log(error, "error");
        Sentry.captureException(`142 Error in invokSend: ${error}`);
      }
    }
  };

  const sendNotifications = async (notificationData) => {
    try {
      createNotificationAssignment(notificationData, usersByClass);
    } catch (error) {
      console.log(error, "error");
      Sentry.captureException(`143 Error in sendNotifications: ${error}`);
    }
  };

  useEffect(() => {
    const id = assignment?.id;
    if (prevAssignmentIdRef.current !== id) {
      prevAssignmentIdRef.current = id;
      activeTogglePendingRef.current = null;
      setIsActive(get(assignment, "active", true));
      return;
    }
    const serverActive = get(assignment, "active", true);
    if (activeTogglePendingRef.current === null) {
      setIsActive(serverActive);
    } else if (serverActive === activeTogglePendingRef.current) {
      activeTogglePendingRef.current = null;
      setIsActive(serverActive);
    }
  }, [assignment]);

  const updateActivity = async (e) => {   
    e.preventDefault();
    const allActivityClasses = get(activityData, 'classes', []);
    const classesForNotification = activityData.updateTOAllClass
      ? allActivityClasses
      : allActivityClasses.filter((cls) => cls?.id == currentClass?.id);
    const notificationData = {
      id: v4(),
      classId: get(currentClass, "id", ""),
      displayName: get(activityData, "displayName", ""),
      senderId: get(currentUser, 'id', ''),
      receiversId: filterClassUsers,
      modified: moment().toISOString(),
      data: {
        chapter: get(activityData, "data.chapter", ""),
        page: get(activityData, "data.page", ""),
        id: get(activityData, "data.id", ""),
        scheduleAt: activityData?.scheduleAt,
        classes: classesForNotification.map((cls) => ({
          id: cls?.id,
          users: cls?.users?.length > 0 ?  cls?.users : null
        })),
         ...(is_extension_activity ? { assignfrom: extensionActivityData } : {assignfrom: null}),
         ...(is_engage_activity ? { config_assignment: engageData } : {config_assignment: null}),
      },
      message: `Your teacher Updated this Activity`,
      type: "update_activity",
      userSeen: []
    };
    if (activityData && activityData.sAssignmentId && !activityData.no_sync) {
      await updateAssignmentToSchoology(activityData);
    }
    if (activityData && activityData.canvas_id && !activityData.no_sync) {
      const canvasClassesToUpdate = activityData.updateTOAllClass
        ? allActivityClasses
        : allActivityClasses.filter((cls) => cls?.id == currentClass?.id);
      const canvasUpdateRequests = canvasClassesToUpdate
        .map((cls) => {
          const selectedClassCanvasInfo = find(userClasses, ['id', cls?.id]);
          return {
          canvas_user_id: currentUser.canvas_id,
          canvas_id: activityData.canvas_id,
          canvas_section_id: get(selectedClassCanvasInfo, 'canvas_id'),
          canvas_course_id: get(selectedClassCanvasInfo, 'canvas_course_id'),
          due_date: get(activityData, "dueDate"),
          weightage: get(activityData, "weightage"),
          displayName: get(activityData, "displayName"),
          max_point: String(activityData.max_point),
          unlock_at: activityData?.scheduleAt,
          classId: cls?.id,
          activityId: activityData?.activityId,
        };
      })
        .filter((item) => item.canvas_section_id && item.canvas_course_id);

      await handleBulkUpdateCanvasAssignment(
        currentUser.canvas_id,
        canvasUpdateRequests,
        currentUser.canvas_auth_id
      );
    }
    setDataLoading(true);
    let updateActivityData = {
      ...activityData,
      retakes: activityData.retakes ? (typeof activityData.retakes === "string" ? activityData.retakes.trim() : activityData.retakes): "",
      dueDate: activityData.dueDate,
      lateDate: activityData.lateDate,
      timeDuration: activityData.timeDuration,
      classes: activityData.classes,
      weightage: activityData.weightage,
      displayName: activityData.displayName,
      classId: activityData.classId,
      rubrics_id:  fetchSelectedRubric || null,
      assignFrom: is_extension_activity ?  extensionActivityData  : null,
      ai_grading_config: activityData.ai_grading_config || {}
    };
    if (currentClass.googleId && !activityData.no_sync) {
      await handleUpdateGoogleAssignment(
        currentUser.googleId,
        updateActivityData,
        currentClass.googleId,
        assignment.googleId
      );
    }

    const matchedObj = find(ownGraphicOrganizer, (obj) => obj.graphic_org_id === assignment?.data?.id);
    if (assignment.data.activity_type === 'graphic_organizer' && matchedObj?.graphic_label?.length > 0) {
      const updateGraphicOrgData = {
        label_position: matchedObj?.graphic_label || [],
        id: assignment?.activityId,
        templateType: templateType || assignment?.data?.copy_of?.templateType
      };
      await dispatch(handleGraphicOrgCustomActivityUpdate(updateGraphicOrgData));
    }

    await dispatch(
      handleUpdateClassActivity(
        assignment?.id,
        updateActivityData,
        activityData.updateTOAllClass,
        linkedSectionClassIds
      )
    );

    await dispatch(handleListClassActivities(currentClass.id));
    await dispatch(handleListClassQuizzes(currentClass.id));
    if (isScheduledToday(activityData?.scheduleAt)) {
      sendNotifications(notificationData);
    }
    toggleActivityDrawer(false);
    setDataLoading(false);
    setActivityData({});
  };
  const updateAssignmentToSchoology = async (quizeDataforCreate) => {
    let sectionId = currentClass.sectionId;
    const classConfig = find(quizeDataforCreate.classes, [
      "id",
      currentClass.id,
    ]);
    if (classConfig && classConfig.sectionId) {
      sectionId = classConfig.sectionId;
    }
    if (currentUser.schoologyid && sectionId) {
      let data = {
        title: quizeDataforCreate.displayName,
        due: `${quizeDataforCreate.dueDate}`,
        grading_category: get(classConfig, "schoologyCategory")
          ? get(classConfig, "schoologyCategory")
          : quizeDataforCreate.schoologyCategory,
      };
      return dispatch(handleUpdateSchoologyAssignment(sectionId, currentUser.id, data, quizeDataforCreate.sAssignmentId, quizeDataforCreate?.activityId ? quizeDataforCreate?.activityId : quizeDataforCreate?.quizId, quizeDataforCreate?.updateTOAllClass));

    }
    return null;
  };
  const updateQuiz = async (e) => {
    e.preventDefault();
    const allQuizClasses = get(quizData, 'classes', []);
    const classesForNotification = quizData.updateTOAllClass
      ? allQuizClasses
      : allQuizClasses.filter((cls) => cls?.id == currentClass?.id);
    const notificationData = {
      id: v4(),
      classId: get(currentClass, "id", ""),
      displayName: get(quizData, "displayName", ""),
      senderId: get(currentUser, 'id', ''),
      receiversId: filterClassUsers,
      modified: moment().toISOString(),
      data: {
        chapter: get(quizData, "data.chapter", ""),
        page: get(quizData, "data.page", ""),
        id: get(quizData, "data.id", ""),
        classes: classesForNotification.map((cls) => ({
          id: cls?.id,
          users: cls?.users?.length > 0 ?  cls?.users : null
        })),
         ...(is_extension_activity ? { assignfrom: extensionActivityData } : {assignfrom: null}),
      },
      message: `Your teacher Updated this Quiz`,
      type: "update_quiz",
      userSeen: []
    };
    if (quizData && quizData.sAssignmentId && !quizData.no_sync) {
      await updateAssignmentToSchoology(quizData);
    }
    if (quizData && quizData.canvas_id && !quizData.no_sync) {
      const canvasClassesToUpdate = quizData.updateTOAllClass
        ? allQuizClasses
        : allQuizClasses.filter((cls) => cls?.id == currentClass?.id);
      const canvasUpdateRequests = canvasClassesToUpdate
        .map((cls) => {
          const selectedClassCanvasInfo = find(userClasses, ['id', cls?.id]);
          return {
          canvas_user_id: currentUser.canvas_id,
          canvas_id: quizData.canvas_id,
          canvas_section_id: get(selectedClassCanvasInfo, 'canvas_id'),
          canvas_course_id: get(selectedClassCanvasInfo, 'canvas_course_id'),
          due_date: get(quizData, "dueDate"),
          weightage: get(quizData, "weightage"),
          displayName: get(quizData, "displayName"),
          max_point: String(quizData.max_point),
          unlock_at: quizData?.scheduleAt,
          classId: cls?.id,
          activityId: quizData?.quizId,
        };
      })
        .filter((item) => item.canvas_section_id && item.canvas_course_id);

      await handleBulkUpdateCanvasAssignment(
        currentUser.canvas_id,
        canvasUpdateRequests,
        currentUser.canvas_auth_id
      );
    }
    if (currentClass.googleId && !quizData.no_sync) {
      await handleUpdateGoogleAssignment(
        currentUser.googleId,
        quizData,
        currentClass.googleId,
        quizData.googleId
      );
    }
    setDataLoading(true);
    await dispatch(
      handleUpdateClassQuiz(
        quizData.id,
        {
          ...quizData,
          retakes: quizData.retakes ? (typeof quizData.retakes === "string" ? quizData.retakes.trim() : quizData.retakes): "",
          dueDate: quizData.dueDate,
          lateDate: quizData.lateDate,
          timeDuration: quizData.timeDuration,
          classes: quizData.classes,
          weightage: quizData.weightage,
          displayName: quizData.displayName,
          scheduleAt: quizData.scheduleAt,
          classId: quizData.classId,
          schoologyCategory: quizData.schoologyCategory,
          rubrics_id:  fetchSelectedRubric,
           ...(is_extension_activity ? { assignfrom: extensionActivityData } : {assignfrom: null}),
        },
        quizData.updateTOAllClass,
        linkedSectionClassIds
      )
    );

    await dispatch(handleListClassActivities(currentClass.id));
    await dispatch(handleListClassQuizzes(currentClass.id));
    sendNotifications(notificationData);
    setDataLoading(false);
    toggleQuizDrawer(false);
    setQuizData({});
  };
  const debouncedActiveDeactiveQuizzes = useMemo(
    () =>
      debounce((id, active) => {
        dispatch(handleChangeStatusQuizzes(id, active));
      }, 800),
    [dispatch]
  );

  const debouncedActiveDeactiveActivites = useMemo(
    () =>
      debounce((id, active) => {
        dispatch(handleChangeStatusActivity(id, active));
      }, 800),
    [dispatch]
  );

  useEffect(() => {
    return () => {
      debouncedActiveDeactiveQuizzes.cancel();
      debouncedActiveDeactiveActivites.cancel();
    };
  }, [debouncedActiveDeactiveQuizzes, debouncedActiveDeactiveActivites]);

  const handleActiveSwitchChange = useCallback(() => {
    const id = get(assignment, "id");
    const typeId = get(assignment, "data.typeId");
    setIsActive((prevState) => {
      const newState = !prevState;
      activeTogglePendingRef.current = newState;
      if (typeId === "quiz" || typeId === "quizresource") {
        debouncedActiveDeactiveQuizzes(id, newState);
      } else {
        debouncedActiveDeactiveActivites(id, newState);
      }
      return newState;
    });
  }, [
    assignment,
    debouncedActiveDeactiveActivites,
    debouncedActiveDeactiveQuizzes,
  ]);
  const updateActivityData = (id, value) => {
    const val =
      value && value.length > 1 && value[0] === "0"
        ? value.replace("0", "")
        : value;
        setActivityData(prevState => ({
          ...prevState,
          [id]: val
      }));
  };

  const updateQuizData = (id, value) => {
    const val =
      value && value.length > 1 && value[0] === "0"
        ? value.replace("0", "")
        : value;
        setQuizData(prevState => ({
          ...prevState,
          [id]: val
      }));
  };

  const openEditQuiz = () => {
    let quiz = assignment;
    if (!isNaN(parseInt(quiz.timeDuration)) && quiz.timeDuration > 0) {
      setDurationSection(true);
    }
      setQuizData({
        editing: true,
        ...quiz,
      });
      toggleQuizDrawer(true);
  };

  const openEditActivity = () => {
    let activity = assignment;
    if (!isNaN(parseInt(activity.timeDuration)) && activity.timeDuration > 0) {
      setDurationSection(true);
    }
    const config1 = get(activity, "ai_grading_config");
    const config2 = get(activity, "data.ai_grading_config");
    const ai_grading_config = !isEmpty(config1) ? config1 : (!isEmpty(config2) ? config2 : {});
    const activityDataToSet = {
      editing: true,
      ...activity,
      ai_grading_config: ai_grading_config,
    };
    setActivityData(activityDataToSet);
    toggleActivityDrawer(true);
  };
  const onCloseDrawer = () => {
    toggleQuizDrawer(false);
    toggleActivityDrawer(false);
    setQuizData({});
    setActivityData({});
    setDataLoading(false);
    setDurationSection(false);
    setTemplateType(null);
  };
  const deleteFromIntegration = async (data) => {
    let classAssignmentIdsToDelete = [];
    if (data?.classes?.length > 0) {
      classAssignmentIdsToDelete = data?.classes?.map((cls) => String(cls?.id));
    } else {
      classAssignmentIdsToDelete = [String(data?.id)];
    }
    if (data && currentClass.sectionId) {
      await handleDeleteSchoologyAssignment(currentUser.schoologyid, data?.activityId || data?.quizId, classAssignmentIdsToDelete)
  }
  if (currentClass.googleId) {
      await handleDeleteGoogleAssignment(currentUser.googleId, data?.activityId || data?.quizId, classAssignmentIdsToDelete)
  }
  if (data && data.canvas_id) {
      try {
        await handleDeleteCanvasAssignment(currentUser.canvas_id, data?.activityId || data?.quizId, classAssignmentIdsToDelete, currentUser.canvas_auth_id);
      } catch (error) {
          Sentry.captureException(`209 Error during handleDeleteCanvasAssignment ${error}.`);
      }
  }
  }
  const deleteCustomAssignment = async () => {
    setDeleteLoading(true);
    await Promise.allSettled([
      await deleteFromIntegration(assignment),
      await dispatch(
        handleDeleteCustomAssignment(get(editCustomAssignmentData, "id"))
      )
    ]);
    setDeleteLoading(false);
    setDeleteModal(false);
    setEditCustomAssignmentData({});
    const bookInfo = get(editCustomAssignmentData, "meta_data.book_info", get(editCustomAssignmentData, "data.meta_data.book_info"));
    const notificationData = {
      id: v4(),
      classId: get(currentClass, "id", ""),
      displayName: get(editCustomAssignmentData, "displayName", ""),
      senderId: get(currentUser, 'id', ''),
      receiversId: filterClassUsers,
      modified: moment().toISOString(),
      data: {
        chapter: get(editCustomAssignmentData, "chapter", ""),
        page: get(editCustomAssignmentData, "page", ""),
        id: get(editCustomAssignmentData, "id", ""),
        ...(bookInfo ? { meta_data: { book_info: bookInfo } } : {}),
      },
      message: `Your teacher Delete this Assignment`,
      type: "delete_activity",
      userSeen: []
    };
    sendNotifications(notificationData);
  };

  const handleClickAiAnswer = (answerData) => {
    invokeAiAnswerView(answerData);
  }


  const getClassAssignment = async () => {
    setReviewLoader(true);
    const assignemtnData = assignment?.data ? assignment?.data : assignment;
    const assignmentId = assignemtnData?.id;
    await Promise.allSettled([dispatch(handleListActivityOrQuizData(assignment.id)),dispatch(handleListSubmissionsByAssignmentAndClass(assignmentId,get(currentClass, "id")))
    ]);

    setReviewLoader(false);
  }

  const handleClassClick = async (selectedClass) => {
    if (!selectedClass || !selectedClass.id) return;
    if (selectedClass.id === currentClass?.id) return;
    if (classSwitchLoading) return;
    
    setClassSwitchLoading(true);
    try {
      await dispatch(handleGetClass(selectedClass.id));
    } finally {
      setClassSwitchLoading(false);
    }
  }

  const onViewAssignment = async (data) => {
    await getClassAssignment()
    toggleAssignmentDrawer(true);
  }

  const autoScrollhandled = () => {
    handleClickAiAnswer(assignment?.data)
    try {
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    } catch (error) {
      Sentry.captureException(`145 Error in autoScrollhandled: ${error}`);
    }
  }

  return (
    <SentryWrap>
      <style>
        {`
          .class-dropdown-menu .ant-dropdown-menu-item.selected-class-item {
            background-color: #e6f7ff !important;
            color: #1890ff !important;
            font-weight: 600 !important;
          }
          .class-dropdown-menu .ant-dropdown-menu-item.selected-class-item:hover {
            background-color: #bae7ff !important;
          }
        `}
      </style>
     {assignmentDrawer?<AssignmentReviewByNotify assignment={assignment} assignmentDrawer={assignmentDrawer} oncloseDrawer={() => {
        toggleAssignmentDrawer(false)
      }} />:null}
      <Drawer
        height="100%"
        destroyOnHidden
        onClose={onCloseDrawer}
        placement="top"
        open={quizDrawer}
        key="quizNew"
        className="assignments-drawer"
      >
        <>
          {quizDrawer && (
            <QuizForm
              data={{ ...quizData, editing: true }}
              handleChange={(e) => updateQuizData(e.target.id, e.target.value)}
              handleChangeLevel={(e) =>
                updateQuizData("levelExercise", e.target.value)
              }
              handleSubmit={updateQuiz}
              setDurationSection={setDurationSection}
              durationSection={durationSection}
              onClose={() => toggleQuizDrawer(false)}
              handleRubric={(val) => {
                setFetchSelectedRubric(val?.id);
              }}
            />
          )}
        </>
      </Drawer>
      <Drawer
        height="100%"
        destroyOnHidden
        onClose={onCloseDrawer}
        placement="top"
        open={activityDrawer}
        key="activityNew"
        className="assignments-drawer"
      >
        <>
          {activityDrawer && (
            <ActivityForm
              data={{ ...activityData, editing: true }}
              handleChange={(e) =>
                updateActivityData(e.target.id, e.target.value)
              }
              handleSubmit={updateActivity}
              setDurationSection={setDurationSection}
              durationSection={durationSection}
              loading={dataLoading}
              onClose={() => toggleActivityDrawer(false)}
              handleRubric={(val) => {
                setFetchSelectedRubric(val?.id);
              }}
              setTemplateType={setTemplateType}
            />
          )}
        </>
      </Drawer>
      <DeleteModal
        message={`Are you sure you want to delete? You will lose all submissions and grades for this assignment.`}
        deleteToggle={deleteModal}
        setDeleteToggle={setDeleteModal}
        loading={deleteLoading}
        onDelete={deleteCustomAssignment}
      />
      {cloneToPageOpen && <CloneActivityToPageModal
        is_assigned={true}
        open={cloneToPageOpen}
        onClose={() => setCloneToPageOpen(false)}
        assignment={assignment?.data || assignment}
      />}
      {editCustomAssignmentModal && <AssignmentForm
        bookId={get(editCustomAssignmentData, "chapter")}
        pageId={get(editCustomAssignmentData, "page")}
        open={editCustomAssignmentModal}
        data={editCustomAssignmentData}
        onClose={() => {
          setEditCustomAssignmentModal(false);
          setEditCustomAssignmentData({});
        }}
      />}
      <TootipWrapper
        hasToolTip={isAssignedAllExam}
        label={`Please edit this ${
          assignment?.data?.typeId === "activity" ? "activity" : "quiz"
        } with Entire exam button.`}
      >
        {isExam ? (
          <ExamAssignmentWrapper
            disabled={isAssignedAllExam}
            deactivated={!isActive}
            bgColor={colorCode}
            isUnitExam={isUnitExam}
            isGeneratedTest={isGeneratedTest}
            className={`11 cardTextWraper ${isUnitExam ? 'addUnitCstm' : ''} ${is_exam ? 'addAssignExamCstm' : ''} ${isGeneratedTest ? 'addGeneratedTestCstm' : ''}`}>
            <div className='assignmentCstmName assignmentNameFlex 111'>
              <div className="assignmentFlexLft">
                <img src={titleIconSvg} alt="" title="" />
                <Tooltip placement="top" title={get(
                    assignment,
                    'displayName',
                    get(assignment, 'data.displayName'),
                    ''
                  )}>  
                <label className='assignedTaskName text-wrap examTitleSection'>
                  {get(
                    assignment,
                    'displayName',
                    get(assignment, 'data.displayName'),
                    ''
                  )}
                </label>
                </Tooltip>
              </div>
              <div className="222 assignmentFlexRght">
              {get(assignment, 'data.activity_type') === 'graphic_organizer' && (
                  <PrintPage
                    data={assignment?.data ? assignment?.data : assignment}
                    isGeneratedTest={isGeneratedTest}
                    isUnitExam={isUnitExam}
                    isExam={is_exam}
                  />
                )}
                {get(assignment, 'data.activity_type') !== 'graphic_organizer' && (
                  <PrintPage
                    data={assignment?.data ? assignment?.data : assignment}
                    isGeneratedTest={isGeneratedTest}
                    isUnitExam={isUnitExam}
                    isExam={is_exam}
                  />
                )}
                {get(assignment, 'data.createdBy') === currentUser?.id && get(assignment, 'data.activity_type') !== 'graphic_organizer' && (
                  <AssignableNotificationShare assignment={assignment?.data} exameshare={false} />
                )}
                <DeleteAssignment
                  onDeleteAssignment={() => {
                   setDeleteModal(true);
                   setEditCustomAssignmentData(assignment.data);
                  }
                 }
                  deleteLoading={deleteLoading}
                  isCustomAssignment={get(assignment, 'data.type') === 'custom' && get(assignment, 'data.activity_type') != 'graphic_organizer'}
                  data={assignment}
                /> 
              </div>
            </div>

         <div className='33 assignNotifyUpr'>
           <div className='assignNotifyLft'>

            <Row style={{ marginBottom: 0 }}>
              <div className="mngwidth">

                {get(assignment, 'scheduleAt') ? (
                  <div className={`cardDetail`}>
                    <div className='cardDetailInr'>
                      <img src={clockSvg} alt="" title="" />
                      <p>Start Date:</p>
                    </div>
                    <span>
                      {moment(get(assignment, "scheduleAt")).format(
                         "MMM DD, YYYY hh:mm A"
                      )}
                   </span>
                  </div>
                ) : null}

                <div className={`${viewType}-assigned-end-date cardDetail`}>
                  <div className='cardDetailInr'>
                   <img src={dueDateSvg} alt="" title="" />
                   <p>Due Date:</p>
                </div>
                <span>
                 {moment(get(assignment, "dueDate")).format(
                   "MMM DD, YYYY hh:mm A"
                 )}
                </span>
              </div>

              </div>
            </Row>

            {get(assignment, 'lateDate') ? (
              <div className='cardDetail'>
              <div className='cardDetailInr'>
                <img src={lastSubSvg} alt="" title="" />
                <p>Late Submission:</p>
              </div>
              <span>
                {moment(get(assignment, 'lateDate')).format(
                  'MMM DD, YYYY hh:mm A'
                )}
              </span>
            </div>
            ) : null}

              <div className='cardDetail'>
                <div className='cardDetailInr'>
                  <img src={statusSvg} alt="" title="" />
                  <p>Status:</p>
                </div>
                <div className="assigned-class-text 111">
                  <DropDownMenu data={assignment?.classes} currentClass={currentClass} onClassClick={handleClassClick} loading={classSwitchLoading} />
                </div>
              </div>

              {showAssignToForCurrentClass && (
  <div className='cardDetail'>
    <div className='cardDetailInr'>
      <img src={assignSvg} alt="" title=""  width={12} height={12}/>
      <p>Assigned to:</p>
    </div>
    <div className="assigned-class-text 111">
      <StudentListDropdown assignment={assignment} classUsers={classUsers} currentClass={currentClass} />
    </div>
  </div>
)}

              <>
              {filterByBook.id &&
                  assignment.data.chapter !== filterByBook.id && (
                    <div className='cardDetail'>
                        <div className='cardDetailInr'>
                         <img src={lastSubSvg} alt="" title="" />
                         <p>Book:</p>
                        </div>
                        <span>{filterByBook?.description}</span>
                    </div>
                  )}
              </>   

            {view_result_on ? <NoteMark note={`Students will see grade after ${view_result_on}.`} /> : null} 


          </div>

          <div className='assignNotifyRght'>
            <img
              src={modalSrc}
              width=''
              height={''}
              alt=''
            />
          </div>
        </div>

        <div className='sharedAssignedTask'>
            <div className='switchCollectUpr 1212 111'>
              
             <FormControlLabel
              control={
                <CustomSwitch
                  className="cstmSwitch"
                  checked={isActive}
                  onChange={handleActiveSwitchChange}
                  name="view"
                />
              }
              label={isActive ? "Active" : "Desactivo"}
              classes={{
                root: classes.root,
                label: classes.label,
              }}
            />

             <ExamsSharedAndAssignedTask
              isSharedActive={
                currentUser?.id !== assignment?.data?.share_by &&
                assignment?.data?.share_by !== '' &&
                !!filterByTeacher
              }
              isAssignedActive={true}
              sharedBy={`${filterByTeacher?.firstName} ${filterByTeacher?.lastName}`}
              isUnitExam={isUnitExam}
              styles={{ right: assignment?.data?.is_ai ? 20 : 0 }}
            />  

              {assignment?.data?.is_ai && (
               <div className='assignAi'><img src={AssignmentAi} alt='Assignment Ai' /></div>
              )}
              {storyInstructionView ? <ShowStoryBtn storyInstruction={storyInstructionView} /> : null}

            </div>
        </div>

        {/* Start of Icons Collection */}

        <div className='switchCollectUpr 333333'>
         <div className='switchCollecLeft'>
            {/* <FormControlLabel
                classes={{
                  root: classes.root,
                  label: classes.label,
                }}
                control={
                  <Switch
                    defaultChecked={isActive}
                    value={isActive}
                    onChange={handleActiveSwitchChange}
                    name="view"
                    color="primary"
                    size="small"
                  />
                }
                label={isActive ? "Active" : "Desactivo"}
              /> */}
            
              <div className="assignmentNotifications">
              {filterClassUsers && filterClassUsers.length > 0 ?  <div className='verResBtn addCursor' onClick={onViewAssignment}>
                {reviewLoader ? <Loading size={18} /> : <span>Ver entregas</span>}
              </div>:null}

              {assignment?.data?.is_ai && (
              <div className='verResBtn addCursor' onClick={() => handleClickAiAnswer(assignment?.data)}>
                <span>Respuestas</span>
              </div>
              )}
              

            {/* <div className="iconCollection 222"> */}

            <Tooltip placement='top' title="Preview">
              <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`} onClick={onPreviewCick}>
                <img src={eyeBtnSvg} alt="" title="" />
                <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Preview</label>
              </div>
            </Tooltip>

            <Tooltip placement='top' title="Editar fechas">
             <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`} 
               onClick={() => {
                if (isAssignedAllExam) {
                  return;
                }
                if (assignment?.data?.typeId === 'activity') {
                  openEditActivity();
                } else {
                  openEditQuiz();
                }
              }}>
               <img src={editorIconSvg} alt="" title="" /> 
               <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Editar fechas</label>
             </div>
            </Tooltip>

            {get(assignment, 'data.activity_type') !== 'graphic_organizer' && (
                  <IconButton
                    className='assignNotifyIcon'
                    color='primary'
                    style={{ padding: 0 }}
                    onClick={() => {
                      setEditCustomAssignmentModal(true);
                      setEditCustomAssignmentData(assignment.data);
                    }}>
                    <Tooltip placement='top' title="Editar pregunta">
                     <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`}>
                       <img src={customEditSvg} alt="" title="" />
                       <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Editar preguntas</label>
                     </div>
                    </Tooltip>
                  </IconButton>
              )}
                  {assignment?.data?.typeId === 'activity' ||
                  assignment?.data?.typeId === 'quiz' ||
                  assignment?.data?.typeId === 'worksheet' ? (
                    <Tooltip
                      placement='top'
                      title={
                        assignment?.data?.typeId === 'worksheet'
                          ? 'Copy grammar drill to another book/page'
                          : assignment?.data?.typeId === 'custom'
                            ? 'Copy or move to another book/page'
                            : 'Copy to another book/page'
                      }
                    >
                      <div className='iconLabel' onClick={() => setCloneToPageOpen(true)}>
                        <CopyAllOutlined />
                      </div>
                    </Tooltip>
                  ) : null}
             </div>
           </div> 
         </div>

        {/* End of Icons Collection */}

        </ExamAssignmentWrapper>

        ) : 
        assignment?.data?.typeId === 'worksheet' ? (
          <WorksheetAssignment worksheetData={worksheetData} isAssigned={true} ActivityData={assignment?.data} page={assignment?.data?.page} bookId={assignment?.chapter} numberMasked={assignment?.numberMasked} pageLearningModuleCount={assignment?.pageLearningModuleCount} />
         ) : (
        <Wrapper
          style={{ paddingRight: "", marginTop: viewType === "balcon" ? "15px"  : "9px" }}
          disabled={isAssignedAllExam}
          deactivated={!isActive}
          bgColor={colorCode}
          isGeneratedTest={isGeneratedTest}
          className={`cardTextWraper 22${isGeneratedTest ? ' addGeneratedTestCstm' : ''}`}
          isGraphicOrganizer={get(assignment, "data.activity_type") === "graphic_organizer"}
        >
          <div className="cardlabelSet">
            <span className={`${get(assignment, "data.activity_type") === "graphic_organizer" ? "graphicOrganizerAssignmentLabel" : "assignmentLabel"}`}>{isGeneratedTest?"ACTIVIDAD GENERADA": get(assignment, "data.activity_type") === "graphic_organizer" ? "ORGANIZADOR GRÁFICO" : "ACTIVIDAD"}</span>
          </div>


          <div className='assignmentCstmName assignmentNameFlex'>
            <div className='assignmentFlexLft'>              
              <img src={titleIconSvg} alt="assigned-note" title="assigned-note" />
              <Tooltip placement="top" title={get(
                  assignment,
                  "displayName",
                  get(assignment, "data.displayName"),
                  ""
                )}> 
                 <Title className='assigned-task-name text-wrap 121212'>
                      {get(
                      assignment,
                      "displayName",
                      get(assignment, "data.displayName"),
                      ""
                    )}
                </Title>
              {/* <label>
                {get(
                  assignment,
                  "displayName",
                  get(assignment, "data.displayName"),
                  ""
                )}
              </label> */}
              </Tooltip>
            </div>
            <div className='333 assignmentFlexRght'>
            {get(assignment, "data.activity_type") === "graphic_organizer" && (
                  <PrintPage
                    data={assignment?.data ? assignment?.data : assignment}
                    isGeneratedTest={isGeneratedTest}
                    isUnitExam={isUnitExam}
                    isExam={is_exam}
                  />
                )}
                {get(assignment, "data.activity_type") !== "graphic_organizer" && (
                  <PrintPage
                    data={assignment?.data ? assignment?.data : assignment}
                    isGeneratedTest={isGeneratedTest}
                    isUnitExam={isUnitExam}
                    isExam={is_exam}
                  />
                )}
                 {get(assignment, 'data.createdBy') === currentUser?.id && get(assignment, 'data.activity_type') !== 'graphic_organizer' && (
                  <AssignableNotificationShare assignment={assignment?.data} />
                )}
                <DeleteAssignment
                  onDeleteAssignment={() => { setDeleteModal(true); setEditCustomAssignmentData(assignment.data);}}
                  deleteLoading={deleteLoading}
                  isCustomAssignment={
                    get(assignment, "data.type") === "custom" &&
                    get(assignment, "data.activity_type") != "graphic_organizer"
                  }
                  data={assignment}
              />
            </div>
          </div>

      
        <div className='44 assignNotifyUpr'>
         <div className='assignNotifyLft'>
      
          <Row className={`${viewType}-start-due-date`} style={{ marginBottom: 0 }}>
            <div className="ovrlpingTxt">
              {get(assignment, "scheduleAt") ? (
                <div className={`${viewType}-assigned-start-date cardDetail`}>
                  <div className='cardDetailInr'>
                    <img src={clockSvg} alt="" title="" />
                    <p>Start Date:</p>
                  </div>
                  <span>
                    {moment(get(assignment, "scheduleAt")).format(
                     "MMM DD, YYYY hh:mm A"
                    )}
                  </span>
                </div>
              ) : null}

              <div className={`${viewType}-assigned-end-date cardDetail`}>
                <div className='cardDetailInr'>
                 <img src={dueDateSvg} alt="" title="" />
                 <p>Due Date:</p>
                </div>
                <span>
                {moment(get(assignment, "dueDate")).format(
                  "MMM DD, YYYY hh:mm A"
                )}
                </span>
              </div>
              
            </div>
          </Row>
          
          {get(assignment, "lateDate") ? (
              <div className='cardDetail'>
               <div className='cardDetailInr'>
                <img src={lastSubSvg} alt="" title="" />
                <p>Late Submission:</p>
               </div>
               <span>
                {moment(get(assignment, "lateDate")).format(
                  "MMM DD, YYYY hh:mm A"
                )}
                </span>
              </div>
          ) : null}

          <div className='cardDetail'>
            <div className='cardDetailInr'>
              <img src={statusSvg} alt="" title="" />
              <p>Status:</p>
            </div>
            <div className="assigned-class-text 222">
              <DropDownMenu data={assignment?.classes} currentClass={currentClass} onClassClick={handleClassClick} loading={classSwitchLoading} />
            </div>
          </div>

          {showAssignToForCurrentClass && (
  <div className='cardDetail'>
    <div className='cardDetailInr'>
      <img src={assignSvg} alt="" title=""  width={12} height={12}/>
      <p>Assign to:</p>
    </div>
    <div className="assigned-class-text 222">
      <StudentListDropdown assignment={assignment} classUsers={classUsers} currentClass={currentClass} />
    </div>
  </div>
)}

          <>
            {filterByBook.id && assignment.data.chapter !== filterByBook.id && (
              <div className='cardDetail'>
                <div className='cardDetailInr'>
                 <img src={lastSubSvg} alt="" title="" />
                 <p>Book:</p>
                </div>
                <span>{filterByBook?.description}</span>
            </div>
            )} 
          </>

         </div>

         <div className='assignNotifyRght'><img src={modalSrc} width="" height={""} alt="" /></div>

        </div>

        <div className='sharedAssignedTask sharedAssignedTaskCstm' style={{ flexWrap: 'wrap' }}>
            <FormControlLabel
                control={
                  <CustomSwitch
                    className="cstmSwitch"
                    checked={isActive}
                    onChange={handleActiveSwitchChange}
                    name="view"
                  />
                }
                label={isActive ? "Active" : "Desactivo"}
                classes={{
                  root: classes.root,
                  label: classes.label,
                }}
            />
            <SharedAndAssignedTask
              isSharedActive={
                currentUser?.id !== assignment?.data?.share_by &&
                assignment?.data?.share_by !== "" &&
                !!filterByTeacher
              }
             isAssignedActive={true}
             sharedBy={`${filterByTeacher?.firstName} ${filterByTeacher?.lastName}`}
           />
           {assignment?.data?.is_ai && (
             <div className='assignAi'><img src={AssignmentAi} alt='Assignment Ai' /></div>
           )}
          {storyInstructionView ? <ShowStoryBtn storyInstruction={storyInstructionView} /> : null}
          {/* New Section start */}
          {is_extension_activity && (
            <span style={{ color: "#03989e", fontFamily: "Poppins", fontSize: "10px" }}>
              (Extension Activity)
            </span>
          )}
        </div>


          
        <div className='switchCollectUpr 1212'>
            <div className='switchCollecLeft'>
              
              <div className="assignmentNotifications">
              {filterClassUsers && filterClassUsers.length > 0 ?  <div className='verResBtn addCursor' onClick={onViewAssignment}>
                {reviewLoader ? <Loading size={18} /> : <span>Ver entregas</span>}
              </div>:null}

              {assignment?.data?.is_ai && (
               <div className='verResBtn addCursor' onClick={() => autoScrollhandled()}>
                <span>Respuestas</span>
               </div>
              )}
              </div>

              {/* Start of Icons Collection */}

                <Tooltip placement='top' title="Preview">
                  <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`} onClick={onPreviewCick}>
                    <img src={eyeBtnSvg} alt="" title="" className='addCursor' />
                    <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Preview</label>
                  </div>
                </Tooltip>  

                <Tooltip placement='top' title="Editar fechas">
                 <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`}
                    onClick={() => {
                      if (isAssignedAllExam) {
                        return;
                      }
                      if (assignment?.data?.typeId === "activity") {
                        openEditActivity();
                      } else {
                        openEditQuiz();
                      }
                    }}>
                   <img src={editorIconSvg} alt="" title="" className='addCursor' />
                   <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Editar fechas</label>
                 </div>
                </Tooltip>


                {get(assignment, "data.activity_type") !== "graphic_organizer" && (
                  <>
                    <IconButton
                      className='editIconCstm'
                      color="primary"
                      style={{ padding: 0 }}
                      onClick={() => {
                        setEditCustomAssignmentModal(true);
                        setEditCustomAssignmentData(assignment.data);
                      }}>
                      <Tooltip placement='top' title="Editar pregunta">
                        <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`}>
                          <img src={customEditSvg} alt="" title="" />
                          <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Editar preguntas</label>
                        </div>
                      </Tooltip>
                    </IconButton>
                      {assignment?.data?.typeId === 'activity' ||
                      assignment?.data?.typeId === 'quiz' ||
                      assignment?.data?.typeId === 'worksheet' ? (
                        <Tooltip
                          placement='top'
                          title={
                            assignment?.data?.typeId === 'worksheet'
                              ? 'Copy grammar drill to another book/page'
                              : assignment?.data?.typeId === 'custom'
                                ? 'Copy or move to another book/page'
                                : 'Copy to another book/page'
                          }
                        >
                          <div className='iconLabel' onClick={() => setCloneToPageOpen(true)}>
                            <CopyAllOutlined />
                          </div>
                        </Tooltip>
                      ) : null}
                  </>
                )}
              </div>
              {/* End of Icons Collection */}
          </div>
        </Wrapper>
        )}
      </TootipWrapper>
    </SentryWrap>
  );
};



export default AssignedNotification;